<!-- <ion-title>Customers</ion-title> -->
<div class="order-list-stiky-header" *ngIf="db.scroll_top && false">
  <!-- <ion-title>Customers</ion-title> -->
  <div class="search__filters d__flex">
    <div class="top__bar">
      <!--  #search -->
      <ion-searchbar [(ngModel)]="db.searchCustomer" (ionChange)="search_customers.emit($event)"></ion-searchbar>
    </div>
    <!-- <ion-item class="sort-buttons d__flex sort__buttons">
            <ion-icon class="sort-icon" src="/assets/icon/date-time.svg"></ion-icon>
            <ion-label>Sort by Name</ion-label>
            <ion-select interface="popover" placeholder="">
            </ion-select>
      </ion-item> -->
    <div class="d__flex main_sort">
      <!-- <ion-item class="sort-buttons d__flex sort__buttons">
        <ion-icon class="sort-icon" src="/assets/icon/sort-by-status.svg"></ion-icon>
        <ion-label>Sort by Phone</ion-label>
        <ion-select interface="popover" placeholder="">
        </ion-select>
      </ion-item>
      <ion-item class="sort-buttons d__flex sort__buttons">
        <ion-icon class="sort-icon" src="/assets/icon/payment-status.svg"></ion-icon>
        <ion-label>Sort by Email</ion-label>
        <ion-select interface="popover" placeholder="">
        </ion-select>
      </ion-item> -->
      <ion-button *ngIf="!db.ismobile && false" slot="end" class="headerButton" (click)="new_customer.emit($event)">
        <ion-icon src="assets/icons/add.svg"></ion-icon>New Customer
      </ion-button>
    </div>
  </div>
</div>
<div class="Fields-5" *ngIf="!db.ismobile">
  <div class="table__data d__flex table__header">
    <div class="txt-center">
      <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
      <!-- <ion-icon class="fnt-14" name="square-outline"></ion-icon> -->
    </div>
    <div class="">Customer Name</div>
    <div class="">Customer Id</div>
    <div class="">Phone Number</div>
    <div class="">Email</div>
  </div>
  <!-- (scroll)="onScroll($event)" -->
  <div [ngClass]="db.scroll_top ? 'orderss__list' : 'orderss_list'" #scrollMe *ngIf="!db.ismobile && customers_list.length != 0" (scroll)="onScroll($event)">
    <div class="main-item mouse" (click)="order_list(item)" *ngFor="let item of customers_list;let i =index">
      <!-- (click)="order_list(item)" -->
      <div class="table__data  d__flex table__items">
        <div class="txt-center">
          <ion-checkbox [checked]="check_box" class="check__box box_icon"></ion-checkbox>
          <!-- <ion-icon class="box_icon" name="square-outline"></ion-icon> -->
        </div>
        <div class="order_id txt_capital">
          <p class="">{{item.full_name}}</p>
        </div>
        <div>{{item.name}}</div>
        <div>{{item.phone}}</div>
        <div>{{item.email}}</div>
      </div>
    </div>
  </div>
</div>
<div class="pl10" *ngIf="db.searchCustomer && customers_list.length == 0">
  <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
    <ion-label>
      <p>
        <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
      </p>
      
    </ion-label>
  </ion-item>
</div>
